(function () {
    emailjs.init("JLN545bRtFF4f-3_U");
})();

function closeM2pModal() {
    document.getElementById('m2p-status-modal').classList.remove('m2p-modal-active');
}

window.onclick = function (event) {
    var modal = document.getElementById('m2p-status-modal');
    if (event.target == modal) closeM2pModal();
}

function showM2pModal(type, title, message) {
    const modalInner = document.getElementById('m2p-modal-inner');
    const iconContainer = document.getElementById('m2p-modal-icon-container');
    const titleEl = document.getElementById('m2p-modal-title');
    const msgEl = document.getElementById('m2p-modal-message');
    const modalOverlay = document.getElementById('m2p-status-modal');

    if (type === 'success') {
        modalInner.classList.remove('m2p-error-theme');
        modalInner.classList.add('m2p-success-theme');
        iconContainer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>';
    } else {
        modalInner.classList.remove('m2p-success-theme');
        modalInner.classList.add('m2p-error-theme');
        iconContainer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';
    }

    titleEl.textContent = title;
    msgEl.textContent = message;
    modalOverlay.classList.add('m2p-modal-active');
}

document.getElementById('m2p-contact-form').addEventListener('submit', function (event) {
    event.preventDefault();

    const btn = document.getElementById('m2p-submit-button');
    const originalText = btn.textContent;
    btn.textContent = 'Sending...';
    btn.disabled = true;

    const phonePrefix = document.getElementById('ContactPhonePrefix').value;
    const phoneNumber = document.getElementById('ContactPhone').value;
    const fullPhone = phonePrefix ? (phonePrefix + " " + phoneNumber) : phoneNumber;

    const formData = {
        country: document.getElementById('ContactCountryInput').value,
        city: document.getElementById('ContactCity').value,
        province: document.getElementById('ContactProvince').value,
        zip: document.getElementById('ContactZip').value,
        address: document.getElementById('ContactAddress').value,
        apt: document.getElementById('ContactApt').value,
        first_name: document.getElementById('ContactFormFirstName').value,
        last_name: document.getElementById('ContactFormLastName').value,
        user_name: document.getElementById('ContactFormFirstName').value + ' ' + document.getElementById('ContactFormLastName').value,
        user_email: document.getElementById('ContactFormEmail').value,
        user_phone: fullPhone,
        sn_code: document.getElementById('ContactSN').value
    };

    emailjs.send("service_r3lt825", "template_nuqcxlm", formData)
        .then(function (response) {
            console.log('SUCCESS!', response.status, response.text);
            showM2pModal('success', 'Success!', 'Thanks for contacting us. We will get back to you as soon as possible.');

            document.getElementById('m2p-contact-form').reset();

            document.getElementById('m2p-select-head').textContent = 'Select your country';
            document.getElementById('m2p-select-head').classList.remove('has-value');
            document.getElementById('ContactCountryInput').value = "";
            document.getElementById('ContactPhonePrefix').value = ""; 

        }, function (error) {
            console.log('FAILED...', error);
            showM2pModal('error', 'Submission Failed', 'Failed to send the message. Please try again later.');
        })
        .finally(function () {
            btn.textContent = originalText;
            btn.disabled = false;
        });
});

const countryData = {
    "Asia": ["China"],
    "North America": ["United States", "Canada"],
    "Europe": [
        "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic",
        "Denmark", "Estonia", "Finland", "France", "Germany", "Greece", "Hungary",
        "Ireland", "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands",
        "Poland", "Portugal", "Romania", "Slovakia", "Slovenia", "Spain", "Sweden",
        "United Kingdom", "Switzerland", "Norway"
    ]
};

const phoneCodes = {
    "China": "+86",
    "United States": "+1",
    "Canada": "+1",
    "Austria": "+43",
    "Belgium": "+32",
    "Bulgaria": "+359",
    "Croatia": "+385",
    "Cyprus": "+357",
    "Czech Republic": "+420",
    "Denmark": "+45",
    "Estonia": "+372",
    "Finland": "+358",
    "France": "+33",
    "Germany": "+49",
    "Greece": "+30",
    "Hungary": "+36",
    "Ireland": "+353",
    "Italy": "+39",
    "Latvia": "+371",
    "Lithuania": "+370",
    "Luxembourg": "+352",
    "Malta": "+356",
    "Netherlands": "+31",
    "Poland": "+48",
    "Portugal": "+351",
    "Romania": "+40",
    "Slovakia": "+421",
    "Slovenia": "+386",
    "Spain": "+34",
    "Sweden": "+46",
    "United Kingdom": "+44",
    "Switzerland": "+41",
    "Norway": "+47"
};

const selectHead = document.getElementById('m2p-select-head');
const selectBody = document.getElementById('m2p-select-body');
const hiddenInput = document.getElementById('ContactCountryInput');
const provinceWrapper = document.getElementById('m2p-province-wrapper');
const provinceInput = document.getElementById('ContactProvince');
const phonePrefixInput = document.getElementById('ContactPhonePrefix');

function initCustomSelect() {
    if (!selectBody) return;

    for (const [region, countries] of Object.entries(countryData)) {
        const groupLabel = document.createElement('div');
        groupLabel.className = 'm2p-select-group-label';
        groupLabel.textContent = region;
        selectBody.appendChild(groupLabel);

        countries.forEach(country => {
            const option = document.createElement('div');
            option.className = 'm2p-select-option';
            option.textContent = country;

            option.onclick = function (e) {
                e.stopPropagation();
                selectOption(country);
            };

            selectBody.appendChild(option);
        });
    }

    selectHead.onclick = function (e) {
        e.stopPropagation();
        toggleSelect();
    };

    document.addEventListener('click', function (e) {
        const countrySelect = document.getElementById('m2p-custom-country-select');

        if (countrySelect && !countrySelect.contains(e.target)) {
            closeSelect();
        }
    });
}

function toggleSelect() {
    selectBody.classList.toggle('open');
    selectHead.classList.toggle('open');
}

function closeSelect() {
    if (selectBody) selectBody.classList.remove('open');
    if (selectHead) selectHead.classList.remove('open');
}

function selectOption(countryName) {
    selectHead.textContent = countryName;
    selectHead.classList.add('has-value');
    hiddenInput.value = countryName;

    if (phoneCodes[countryName]) {
        phonePrefixInput.value = phoneCodes[countryName];
    } else {
        phonePrefixInput.value = "";
    }

    checkRegionLogic(countryName);
    closeSelect();
}

function checkRegionLogic(countryName) {
    const europeCountries = countryData["Europe"];
    if (europeCountries.includes(countryName)) {
        provinceWrapper.style.display = 'none';
        provinceInput.removeAttribute('required');
        provinceInput.value = "";
    } else {
        provinceWrapper.style.display = 'flex';
        provinceInput.setAttribute('required', 'required');
    }
}

initCustomSelect();